import { config } from "src/config/config";
import {
  getCurrentAccountInfoAPI,
  updateCurrentAccountInfoAPI,
} from "src/service/account_api";

export const ACCOUNT_ACTIONS = {
  INIT_GET_CURRENT_ACCOUNT: "INIT_GET_CURRENT_ACCOUNT",
  START_GET_CURRENT_ACCOUNT: "START_GET_CURRENT_ACCOUNT",
  GET_CURRENT_ACCOUNT_INFO: "GET_CURRENT_ACCOUNT_INFO",
  INIT_UPDATE_CURRENT_ACCOUNT: "INIT_UPDATE_CURRENT_ACCOUNT",
  START_UPDATE_CURRENT_ACCOUNT: "START_UPDATE_CURRENT_ACCOUNT",
  UPDATE_CURRENT_ACCOUNT_INFO: "UPDATE_CURRENT_ACCOUNT_INFO",
};

export const initGetCurrentAccount = () => ({
  type: ACCOUNT_ACTIONS.INIT_GET_CURRENT_ACCOUNT,
});

export const startGetCurrentAccount = () => ({
  type: ACCOUNT_ACTIONS.START_GET_CURRENT_ACCOUNT,
});

export const getCurrentAccountInfo = (data: any) => ({
  type: ACCOUNT_ACTIONS.GET_CURRENT_ACCOUNT_INFO,
  data,
});

export const getCurrentAccountInfoDispatch =
  (params: any) => (dispatch: Function) => {
    const options = {
      userCurrency: params.userCurrency,
    };

    dispatch(startGetCurrentAccount());

    return getCurrentAccountInfoAPI(options)
      .done((data) => {
        if (config.APP_DEBUG) {
          console.log("Received current account info: ", data);
        }
        dispatch(getCurrentAccountInfo(data));
      })
      .fail(() => {
        if (config.APP_DEBUG) {
          console.error("Error in getting current account info");
        }
      });
  };

export const initUpdateCurrentAccount = () => ({
  type: ACCOUNT_ACTIONS.INIT_UPDATE_CURRENT_ACCOUNT,
});

export const startUpdateCurrentAccount = () => ({
  type: ACCOUNT_ACTIONS.START_UPDATE_CURRENT_ACCOUNT,
});

export const updateCurrentAccountInfo = (data: any) => ({
  type: ACCOUNT_ACTIONS.UPDATE_CURRENT_ACCOUNT_INFO,
  data,
});

export const updateCurrentAccountDispatch =
  (params: any) => (dispatch: Function) => {
    let options = {
      username: params.username,
      email: params.email,
      firstName: params.firstName,
      lastName: params.lastName,
    };

    dispatch(startUpdateCurrentAccount());

    return updateCurrentAccountInfoAPI(options)
      .done((data) => {
        if (config.APP_DEBUG) {
          console.log("Received updated account info: ", data);
        }
        dispatch(updateCurrentAccountInfo(data));
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in updating current account info");
        }
      });
  };
